import { toast } from "react-hot-toast";
import { createAsyncThunk } from "@reduxjs/toolkit";
import apiAxios from "../../../services/apiAxios";

export const getLookupMargins = createAsyncThunk(
  "lookup/getLookupMargins",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await apiAxios.get("api/lookup/margin");
      return data;
    } catch (error) {
      return rejectWithValue(error.toString());
    } finally {
    }
    }
);


export const saveLookupMargins = createAsyncThunk(
  "lookup/saveLookupMargins",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await apiAxios.post("api/lookup/margin", payload);
      toast.success(data?.message);
      dispatch(getLookupMargins());
      return data;
    } catch (error) {
      toast.error(error.toString());
      return rejectWithValue(error.toString());
    } finally {
    }
    }
);
